import {Component} from '@angular/core';
import {PreviousUrlService} from '../../../_services/previous-url.service';

@Component({
	selector: 'app-knowledge-base-router',
	templateUrl: './knowledge-base-router.component.html'
})

export class KnowledgeBaseRouterComponent {
	constructor(public previousUrlService: PreviousUrlService) {}
}
